import { cn } from "../../../lib/cn";
import { Pressable } from "../../Pressable";
import { Label } from "../../typography/Label";
import { useMessage } from "./Context";
import { MessageStatus } from "./Status";

export function MessageMetadata() {
    const { sender, showSenderRow } = useMessage();

    return (
        <div
            className={cn(
                "flex max-w-full flex-row items-end gap-8 overflow-x-hidden overflow-y-hidden",
                sender === "member" ? "flex-row-reverse" : undefined,
                showSenderRow ? undefined : "hidden",
            )}
        >
            <MetadataContent />
        </div>
    );
}

function MetadataContent() {
    const { sentAt, senderName, topic, topicHref, deliveryStatus } = useMessage();

    if (deliveryStatus === "sending" || deliveryStatus === "failed") {
        return <MessageStatus />;
    }

    return (
        <>
            <Label size="xsmall" weight="bold" className="whitespace-nowrap">
                {sentAt}
            </Label>

            {senderName && (
                <Label
                    size="xsmall"
                    weight="bold"
                    color="tertiary"
                    className="whitespace-nowrap"
                >
                    {senderName}
                </Label>
            )}

            {topic && (
                <Pressable href={topicHref}>
                    <Label size="xsmall" weight="bold" className="whitespace-nowrap">
                        {topic}
                    </Label>
                </Pressable>
            )}
        </>
    );
}
